import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const logStateMiddleware = ({dispatch, getState}) => next => action => {
    //console.log(action.type, getState())
    next(action)
};

const store = createStore(reducers, applyMiddleware(thunk, logStateMiddleware));



export default store;